import { render, staticRenderFns } from "./upcoming-reservation.vue?vue&type=template&id=2021ed17&scoped=true&"
import script from "./upcoming-reservation.vue?vue&type=script&lang=ts&"
export * from "./upcoming-reservation.vue?vue&type=script&lang=ts&"
import style0 from "./upcoming-reservation.vue?vue&type=style&index=0&id=2021ed17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021ed17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VMenu,VProgressCircular})
